import { type DateArg, isFuture, isToday } from "date-fns";
import { StyleSheet, View } from "react-native";
import { BaseText } from "~/components/layout/text";

import { Space } from "~/constants/sizing";
import { useTheme } from "~/providers/ThemeProvider";
import { filled } from "~/util";

type DayProps = {
    day?: number;
    today?: boolean;
    disabled?: boolean;
    colour?: string;
    now?: boolean;
    date?: DateArg<Date>;
    period?: boolean;
    periodColour?: string;
};

export const DAY_SIZE = Space.xl;

export const Day = ({ day, today, disabled, colour, now, date, period, periodColour }: DayProps) => {
    const { colours, border, background } = useTheme();

    const is_now = now || (date ? isToday(date) : false);
    const is_future = filled(date) && isFuture(date);

    return (
        <View
            style={[
                styles.day,
                period && [
                    border.brand,
                    background.brand,
                    periodColour ? { backgroundColor: periodColour } : styles.period,
                    { borderColor: colours.tracking.feature },
                    is_future && styles.futurePeriod,
                ],
                today && { backgroundColor: colours.tracking.selected },
                disabled && background.transparent,
            ]}
        >
            <BaseText
                weight="semibold"
                lineHeight="sm"
                colour={
                    (disabled && "quaternary") || (today && "inverse-primary") || (is_now && "secondary") || "primary"
                }
                style={filled(colour) && !today && !disabled && { color: colour }}
            >
                {day}
            </BaseText>
        </View>
    );
};

const styles = StyleSheet.create({
    day: {
        borderRadius: DAY_SIZE,
        justifyContent: "center",
        alignItems: "center",
        width: DAY_SIZE,
        height: DAY_SIZE,
        overflow: "hidden",
        borderWidth: 2,
        borderColor: "transparent",
        borderStyle: "solid",
    },
    period: {
        borderStyle: "solid",
    },
    futurePeriod: {
        borderStyle: "dashed",
    },
});
